@if (sliderService.isSliderOpen(type())) {
  <div
    class="panel-right"
    [ngClass]="embeddedPanelNgClass"
    [style.--embedded-panel-flex]="embeddedCustomWidthStyle">
    @if (!embedded()) {
      <div
        class="panel-right_overlay"
        aria-hidden="true"
        (click)="close()"
        (wheel)="bloquerDefilementFond($event)"
        (touchmove)="bloquerDefilementFond($event)"
        @panelRightFade></div>
    }
    <div
      class="panel-right_container -{{ width() }}"
      tabindex="-1"
      [attr.role]="isModal() ? 'dialog' : 'region'"
      [attr.aria-modal]="isModal() ? 'true' : null"
      [attr.aria-labelledby]="headerContent() ? null : titleId"
      [attr.aria-label]="headerContent() ? (title() || null) : null"
      @panelRightSlide>
      @if (headerContent()) {
        <ng-container [ngTemplateOutlet]="headerContent()">
          <div class="panel-right_header content" [ngClass]="{'no-border': !headerBorder()}">
            <h2 class="panel-right_header_title" [ngStyle]="{'font-size': titleSize()}">
              {{ title() }}
            </h2>
          </div>
          @if (subtitle()) {
            <div class="subtitle">
              <p>{{ subtitle() }}</p>
            </div>
          }
        </ng-container>
      } @else {
        <div class="panel-right_header">
          @if (showBackArrow()) {
            <button type="button" (click)="close()" class="button-white-icon" aria-label="Retour">
              <i class="icon icon-arrow-left" aria-hidden="true"></i>
            </button>
          }
          <h2 class="panel-right_header_title" [id]="titleId" [ngStyle]="{'font-size': titleSize()}">
            {{ title() }}
          </h2>
          @if (!showBackArrow()) {
            <button type="button" class="panel-right_close" (click)="close()" aria-label="Fermer">
              <i class="icon icon-close" aria-hidden="true"></i>
            </button>
          }
        </div>
        @if (subtitle()) {
          <div class="subtitle">
            <p>{{ subtitle() }}</p>
          </div>
        }
      }
      <div
        class="panel-right_row"
        [class.panel-right_row--embed-child-scroll]="embedded() && embedBodyScrollInChild()"
        [ngClass]="{'-no-padding': !padding(), 'no-border': !headerBorder()}">
        @if (customContent()) {
          <ng-container [ngTemplateOutlet]="customContent()"></ng-container>
        }
      </div>
      @if (footerContent()) {
        <div class="panel-right_footer" [ngClass]="{'bordered': footerBorder()}">
          <ng-container [ngTemplateOutlet]="footerContent()"></ng-container>
        </div>
      }
    </div>
  </div>
}
